module.exports = __webpack_public_path__ + "img/MM.cd4882e2.svg";